import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Paper, Slide } from '@material-ui/core'
import { Button } from '@refera/ui-web'
import Draggable from 'react-draggable'

import useStyles from './styles'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const PaperComponent = props => {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} />
    </Draggable>
  )
}

function onBackdropClick(event, onClose) {
  event.stopPropagation()
  onClose && onClose()
}

export function DraggableModal({
  open,
  onClose,
  isSubmitDisabled,
  onSubmit,
  title,
  children = null,
  showCloseButton = true,
  showSubmitButton = true,
  closeButtonText = 'Cancelar',
  submitButtonText = 'Salvar',
}) {
  const styles = useStyles()

  return (
    <Dialog
      open={open}
      maxWidth="auto"
      className={styles.modal}
      onEscapeKeyDown={onClose}
      onClose={onClose}
      BackdropProps={{ onClick: e => onBackdropClick(e, onClose) }}
      PaperComponent={PaperComponent}
      TransitionComponent={Transition}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} className={styles.dialogTitle} id="draggable-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent onClick={e => e.stopPropagation()}>{children}</DialogContent>
      <DialogActions className={styles.modalButtons} onClick={e => e.stopPropagation()}>
        {showCloseButton && (
          <Button color="red" variant="secondary" className={styles.button} onClick={onClose}>
            {closeButtonText}
          </Button>
        )}
        {showSubmitButton && (
          <Button
            variant="primary"
            className={styles.button}
            onClick={onSubmit}
            disabled={isSubmitDisabled}
          >
            {submitButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
